interface LoadingSpinnerProps {
  message?: string;
  className?: string;
  spinnerClassName?: string;
}

export function LoadingSpinner({
  message = 'Loading...',
  className = 'text-muted-foreground',
  spinnerClassName = 'border-primary',
}: LoadingSpinnerProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={message}
      className="flex min-h-screen items-center justify-center bg-background"
    >
      <div className="text-center">
        <div
          className={`inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid ${spinnerClassName} border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]`}
        />
        <p className={`mt-4 text-sm ${className}`}>{message}</p>
      </div>
    </div>
  );
}
